const TYPES = {
  AGENCY: 'agency_user',
  LOCATION: 'location_user',
  SUBSCRIBER: 'subscriber',
  SUPER_ADMIN: 'super_admin',
  TEACHER: 'teacher',
}

const ROLES = {
  AGENCY: 'agency',
  ADMIN: 'admin',
  POS: 'pos',
  CONSUMER: 'consumer',
  TEACHER: 'teacher',
}

export { TYPES, ROLES }
